module.exports = __webpack_public_path__ + "img/MapThumb_GhostLake.dccb51f2.webp";